import { GLOBAL_VALUES } from 'eebac/constants';
import { clearGloablMessage, setLoading, setGlobalMessage } from '../app';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import RFQ_FIELDS_PART_0 from 'eebac/constants/fields/compnay/rfq/rfq_part_0';
import RFQ_FIELDS_PART_1 from 'eebac/constants/fields/compnay/rfq/rfq_part_1';
import RFQ_FIELDS_PART_2 from 'eebac/constants/fields/compnay/rfq/rfq_part_2';
import RFQ_FIELDS_PART_3 from 'eebac/constants/fields/compnay/rfq/rfq_part_3';
import RFQ_FIELDS_PART_4 from 'eebac/constants/fields/compnay/rfq/rfq_part_4';
import RFQ_FIELDS_PART_5 from 'eebac/constants/fields/compnay/rfq/rfq_part_5';
import RFQ_FIELDS_PART_6 from 'eebac/constants/fields/compnay/rfq/rfq_part_6';
import RFQ_FIELDS_PART_7 from 'eebac/constants/fields/compnay/rfq/rfq_part_7';
import { ALERT_SEVERITY, ERROR_MESSAGES, VALIDATION_MESSAGES } from 'eebac/constants';
import { Catch } from '../api_exception';
import { openRfq } from './user/work/contractors';
import { loadPosts, openPost, setEditPost } from './user/work/posts';
import { loadRfqs, setEditRfq } from './user/work/rfqs';


const BASE_PATH = 'COMPANY_RFQ_INFO';

export const SET_RFQ_INFO_DATA = `${BASE_PATH}/SET_RFQ_INFO_DATA`;
export const VALIDATE_RFQ_INFO_DATA = `${BASE_PATH}/VALIDATE_RFQ_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;

export const sendRfq = (vendorId = null, isPost = false, isEdit = false) =>
    (dispatch, getState, client) => {

        let state = getState();
        state = state.COMPANY_RFQ_DATA;

        let FIELDS = {
            ...RFQ_FIELDS_PART_0,
            ...RFQ_FIELDS_PART_1,
            ...RFQ_FIELDS_PART_2,
            ...RFQ_FIELDS_PART_3,
            ...RFQ_FIELDS_PART_4,
            ...RFQ_FIELDS_PART_5,
            ...RFQ_FIELDS_PART_6,
            ...RFQ_FIELDS_PART_7
        };

        dispatch(setLoading(true));
        let apiData = ApiDataHelper.get(state, FIELDS);
        if (!isPost) {
            apiData.vendorId = vendorId;
        }

        if (!apiData.boq || typeof apiData.boq != "object") {
            apiData.boq = null;
        }

        let apiURI = isPost ? '/company/work_post' : '/company/rfq';

        let request = null;
        if (isEdit) {
            apiData.id = state.id;
            request = client.put(apiURI, apiData);
        } else {
            request = client.post(apiURI, apiData);
        }

        request
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    if (isPost) {
                        dispatch(openPost(false));
                        dispatch(setEditPost(false));
                        dispatch(loadPosts());
                    } else {
                        dispatch(openRfq(false, '', null));
                        dispatch(setEditRfq(false));
                        dispatch(loadRfqs());
                    }

                    dispatch(clearRfqInfoData());
                } else {
                    if (result.fieldErrors &&
                        Array.isArray(result.fieldErrors)) {
                        dispatch(setRfqInfoData(result.fieldErrors))
                    }

                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }

            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const setRfqInfoData = data => ({
    type: SET_RFQ_INFO_DATA,
    data
});

export const validateRfqInfoData = () => ({
    type: VALIDATE_RFQ_INFO_DATA,
});

export const clearRfqInfoData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    workType: "",
    state: "",
    city: '',
    subject: '',
    companyType: '',
    projectName: '',
    projectLocation: '',
    workQty: '',
    unit: '',
    structure: '',
    workScope: '',
    boq: null,
    specifications: '',
    about: '',
    expireAt: new Date(),

    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_RFQ_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VALIDATE_RFQ_INFO_DATA:
            return { ...state, validate: true }

        case CLEAR_INFO_DATA:
            return { ...initialState }
    }

    return state;
}